module.exports = __webpack_public_path__ + "static/img/roleInfo.d5dd636.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/role/character_1/roleInfo.png
// module id = jg6U
// module chunks = 1